var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-100"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.63,
    y: 125.04,
    width: 239.02,
    height: 197.36,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.63,
    y: 129.23,
    width: 235.19,
    height: 189.16,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.08 264.57 356.08 197.74 349.13 197.74 349.13 188.91 333.51 181.6 333.51 172.57 330.91 172.57 330.91 197.74 328.3 197.74 328.3 264.57 324.83 264.57 324.83 229.85 317.02 229.85 317.02 211.63 314.42 211.63 314.42 264.57 308.34 264.57 308.34 244.61 304 244.61 304 239.4 294.45 239.4 294.45 221.18 289.25 221.18 289.25 209.02 283.17 209.02 283.17 190.8 280.56 190.8 280.56 209.02 274.49 209.02 274.49 221.18 269.28 221.18 269.28 239.4 259.73 239.4 259.73 244.61 255.4 244.61 255.4 264.57 250.19 264.57 250.19 239.4 240.64 239.4 240.64 183.85 238.03 183.85 238.03 177.78 217.21 177.78 217.21 183.85 212.87 183.85 212.87 223.78 195.51 223.78 195.51 228.12 189.43 228.12 189.43 230.72 195.51 230.72 195.51 246.34 177.28 246.34 177.28 194.27 173.81 194.27 173.81 183.85 165.13 183.85 165.13 143.93 162.52 143.93 162.52 183.85 156.45 183.85 156.45 194.27 122.63 194.27 122.63 318.39 357.81 318.39 357.81 264.57 356.08 264.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 238.22,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.7,
    y: 242.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 238.22,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 242.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 234.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.51,
    y: 242.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.42,
    y: 258.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 250.59,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 254.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 258.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 262.95,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.32,
    y: 279.45,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 234.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 246.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 250.59,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 254.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 258.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 262.95,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 279.45,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 234.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 238.22,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 242.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 246.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 250.59,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 254.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 258.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 262.95,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 267.08,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 234.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 246.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 250.59,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 254.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.04,
    y: 258.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 196.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 201.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 205.24,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 209.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 213.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 217.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 221.73,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 225.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 229.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 234.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 246.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 250.59,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 254.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.92,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.83,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.73,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.64,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 223.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.54,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 186.28,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 190.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 194.53,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 223.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.45,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.89,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.7,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.61,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 282.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.51,
    y: 286.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 282.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 286.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.42,
    y: 290.58,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 274.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 278.22,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 282.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 286.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 290.58,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.26,
    y: 274.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 274.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 199.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 204.01,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 208.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 212.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 216.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 220.5,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 224.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 228.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.89,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 223.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 264.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 276.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 281.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 285.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 223.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 285.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.81,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 198.65,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 202.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 206.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 211.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 215.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 219.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 223.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 276.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 281.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 264.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 276.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 285.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 293.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 297.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 305.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 309.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 314.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 264.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 276.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 293.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 301.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 305.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 309.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.76,
    y: 314.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 227.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 231.64,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 235.76,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 239.88,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 244,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 248.13,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 252.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 256.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 260.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 264.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 268.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 272.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 276.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 281.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 289.35,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 297.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 301.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 305.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 309.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.66,
    y: 314.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 251.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 255.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 259.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 263.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 267.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 271.63,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 284,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 288.12,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 292.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 296.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 300.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 304.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.94,
    y: 308.74,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 251.02,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 255.14,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 259.27,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 263.39,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 267.51,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 271.63,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 284,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 288.12,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 292.25,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 296.37,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 300.49,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 304.62,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 312.86,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 274.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 282.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 286.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 290.58,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 294.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 298.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 302.95,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 307.08,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 311.2,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 232.87,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 236.99,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 241.11,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 245.23,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 249.36,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 253.48,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 257.6,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 261.72,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 265.85,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 269.97,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 274.09,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 278.22,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 282.34,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 286.46,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 290.58,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 294.71,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 298.83,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 302.95,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 307.08,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.51,
    y: 311.2,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 248.92,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 253.05,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 257.17,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 261.29,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 265.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 269.54,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 273.66,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 277.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 281.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.36,
    y: 286.03,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 248.92,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 253.05,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 257.17,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 261.29,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 265.41,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 269.54,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 273.66,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 277.78,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.27,
    y: 281.9,
    width: 2.46,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.03,
    y: 125.5,
    width: 4.13,
    height: 196.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.39,
    y: 125.5,
    width: 4.13,
    height: 196.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.74,
    y: 125.5,
    width: 4.13,
    height: 196.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.71,297.22H219.12v-.84c0-1.65,1.84-3,4-2.87l4.94.2c2,.08,3.62,1.34,3.62,2.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,274.39a1.64,1.64,0,0,0-1.63-1.56H189.1a1.64,1.64,0,0,0-1.63,1.56l2.65,23.25h16.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,238.63H228l-4.67,43.92h4.16a1.41,1.41,0,0,0,1.38-1.24l4.41-41.43A1.11,1.11,0,0,0,232.2,238.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,282.55H163.45a1.1,1.1,0,0,1-1.12-1.24l4.41-41.43a1.43,1.43,0,0,1,1.38-1.25h62.32a1.11,1.11,0,0,1,1.12,1.25l-4.41,41.43A1.41,1.41,0,0,1,225.77,282.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.61,278.5H165.84a1,1,0,0,1-1-1.09l3.85-36.15a1.23,1.23,0,0,1,1.21-1.08h58.76a1,1,0,0,1,1,1.08l-3.85,36.15A1.24,1.24,0,0,1,224.61,278.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.01,
    y: 295.84,
    width: 22.29,
    height: 1.81,
    rx: 0.9,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.13,
    y: 297.12,
    width: 50.74,
    height: 7.65,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.49,382.61h-1.27a.29.29,0,0,1-.29-.29l-2-77.54h5.85l-2,77.54A.3.3,0,0,1,116.49,382.61Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.33 382.61 68.4 382.61 76.66 304.78 82.52 304.78 71.33 382.61",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.84 382.61 259.84 382.61 248.63 304.78 254.48 304.78 262.74 382.61 259.84 382.61",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.28,
    y: 297.12,
    width: 148.32,
    height: 7.65,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.97 382.61 213.61 382.61 213.61 382.6 212.36 304.78 218.22 304.78 216.97 382.61",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,295.75H168a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.31.31,0,0,1,.29.22l.44,1.64A.31.31,0,0,1,169.59,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,295.75h-1.56a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.31.31,0,0,1,.29.22l.43,1.64A.3.3,0,0,1,171.74,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.88,295.75h-1.55a.31.31,0,0,1-.3-.3v-1.64a.3.3,0,0,1,.3-.3h1.12a.29.29,0,0,1,.28.22l.44,1.64A.3.3,0,0,1,173.88,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,295.75h-1.55a.3.3,0,0,1-.3-.3v-1.64a.29.29,0,0,1,.3-.3h1.11a.29.29,0,0,1,.29.22l.44,1.64A.3.3,0,0,1,176,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.18,295.75h-1.55a.3.3,0,0,1-.3-.3v-1.64a.29.29,0,0,1,.3-.3h1.11a.3.3,0,0,1,.29.22l.44,1.64A.3.3,0,0,1,178.18,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,295.75h-1.56a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.31.31,0,0,1,.29.22l.43,1.64A.3.3,0,0,1,180.33,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.48,295.75h-1.56a.31.31,0,0,1-.3-.3v-1.64a.3.3,0,0,1,.3-.3H182a.29.29,0,0,1,.28.22l.44,1.64A.3.3,0,0,1,182.48,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,295.75h-1.55a.31.31,0,0,1-.3-.3v-1.64a.3.3,0,0,1,.3-.3h1.12a.29.29,0,0,1,.28.22l.44,1.64A.3.3,0,0,1,184.62,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,295.75h-1.55a.3.3,0,0,1-.3-.3v-1.64a.29.29,0,0,1,.3-.3h1.11a.29.29,0,0,1,.29.22l.44,1.64A.3.3,0,0,1,186.77,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,295.75h-1.56a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.3.3,0,0,1,.29.22l.44,1.64A.31.31,0,0,1,188.92,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.07,295.75h-1.56a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.31.31,0,0,1,.29.22l.43,1.64A.3.3,0,0,1,191.07,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,295.75h-1.55a.31.31,0,0,1-.3-.3v-1.64a.3.3,0,0,1,.3-.3h1.12a.29.29,0,0,1,.28.22l.44,1.64A.3.3,0,0,1,193.21,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.36,295.75h-1.55a.3.3,0,0,1-.3-.3v-1.64a.29.29,0,0,1,.3-.3h1.11a.29.29,0,0,1,.29.22l.44,1.64A.3.3,0,0,1,195.36,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,295.75H196a.3.3,0,0,1-.3-.3v-1.64a.29.29,0,0,1,.3-.3h1.11a.3.3,0,0,1,.29.22l.44,1.64A.3.3,0,0,1,197.51,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,295.75H198.1a.3.3,0,0,1-.29-.3v-1.64a.29.29,0,0,1,.29-.3h1.12a.31.31,0,0,1,.29.22l.43,1.64A.3.3,0,0,1,199.66,295.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.47,
    y: 294.63,
    width: 34.75,
    height: 2.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,311.77h53.74a4.67,4.67,0,0,1,4.67,4.67V320a0,0,0,0,1,0,0H81.43a0,0,0,0,1,0,0v-3.53A4.67,4.67,0,0,1,86.1,311.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.49,366.65l20.21-2V336.26h8v28.4l20.29,2a3.94,3.94,0,0,1,3.55,3.92v3H79.94v-3A3.94,3.94,0,0,1,83.49,366.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18,377.37a5.24,5.24,0,1,0,5.23-5.24A5.24,5.24,0,0,0,128.18,377.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,377.37a5.24,5.24,0,1,1-5.23-5.24A5.24,5.24,0,0,1,87.31,377.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.18,317.07h3.05a3.86,3.86,0,0,1,3.86,3.86v21.44a0,0,0,0,1,0,0H102.32a0,0,0,0,1,0,0V320.93A3.86,3.86,0,0,1,106.18,317.07Z",
    transform: "translate(215.41 659.44) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,312.3a348.42,348.42,0,0,1-10.41-74,10.4,10.4,0,0,0-10.4-10H78.9a10.4,10.4,0,0,0-10.41,10.35c-.07,17,1.11,51.71,10.69,79.93l35.49-1.3A4,4,0,0,0,118.35,312.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,316.67a367.11,367.11,0,0,1-11.16-77.19,9.58,9.58,0,0,0-9.59-9.21H75.39a9.58,9.58,0,0,0-9.6,9.54c-.07,15.67,1,50.83,9.86,76.86Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,291.91s20.44-4.13,40.17-2.13-9.28,27.78-9.28,27.78h-4.08s15.38-16.35,14.52-20.41-39.58,1.29-39.58,1.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.66,316.67h33.46A367.08,367.08,0,0,1,98,239.49a9.58,9.58,0,0,0-9.59-9.22h-13a9.58,9.58,0,0,0-9.6,9.54C65.72,255.48,66.82,290.63,75.66,316.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.98,
    y: 315.87,
    width: 71.78,
    height: 4.1,
    rx: 1.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73,348.42c0-.37,1.26-37,7.22-42.84,5.8-5.64,12.46-.21,12.74,0l.6-.72c-.07-.06-7.59-6.2-14,0-6.23,6.06-7.45,42-7.5,43.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.22,355.63c0-.44,4.08-44-11.84-62.29l-.7.61c15.65,18,11.65,61.15,11.61,61.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.81,351l.93-.06c0-.5-3.11-49.55,8.56-60.29l-.63-.69C395.67,301,398.68,349,398.81,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.29,351h.93c0-1.36-.38-33.14-9.41-38.31a6.34,6.34,0,0,0-5.84-.57c-5.46,2.25-8.17,12-8.28,12.38l.9.25c0-.1,2.7-9.69,7.74-11.77a5.52,5.52,0,0,1,5,.51C396.91,318.39,397.29,350.67,397.29,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,351l.93-.06c0-.25-1.36-25.12,5.35-33.88,1.62-2.12,3.39-3.13,5.25-3,4.4.31,8.09,6.74,8.12,6.81l.82-.46c-.16-.29-4-6.94-8.87-7.28-2.19-.16-4.24,1-6.06,3.37C399.42,325.55,400.75,350,400.81,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,354.4c.19-2.41,4.39-59.19-3-69.2l-.75.56c7.2,9.72,2.88,68,2.83,68.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,317.86s4.43,1.64,3.11,5.5-15.35,10.22-15.35,10.22-5.88-5.39-.48-14.15S380.84,315.1,381,317.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25,310.51s-4.73-.2-5,3.87,10.24,15.34,10.24,15.34,7.5-2.71,5.89-12.87S401.42,308,400.25,310.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.25,291s-3.15-.34-2.9-2.26,12.25-6.85,19.33,1.13c0,0-4.53,7.79-11.08,7.89S404.25,291,404.25,291Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.38,286.35s2.85,1.38,3.65-.38-6.77-12.3-17-9.26c0,0-.27,9,5.24,12.55S398.38,286.35,398.38,286.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,316.31s-2.18-1.76.17-2.62,13.86-.61,14,10.8c0,0-13.41,2.23-15.07-2.12S413.3,316.31,413.3,316.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,290.73s2.17-1.76-.17-2.62-13.86-.61-14,10.8c0,0,13.41,2.22,15.07-2.12S386,290.73,386,290.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,299.91s.19-2.13-1.53-1.29-7.73,7.31-1.51,13.45c0,0,8.38-6.2,6.87-9.43S393,299.91,393,299.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.24,303s-1.3-1.71.6-1.92,10.44,2.07,8.45,10.58c0,0-10.39-.78-10.84-4.32S415.24,303,415.24,303Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 382.61 415.79 382.61 419.63 343.56 376.28 343.56 380.13 382.61",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 339.25,
    width: 47.16,
    height: 8.62,
    transform: "translate(795.91 687.12) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-100"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-100",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.06,89.93a10.4,10.4,0,1,1-14.21-3.81A10.41,10.41,0,0,1,179.06,89.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,89.93a10.4,10.4,0,1,1-14.21-3.81A10.41,10.41,0,0,1,179.06,89.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,94.22c.32.56,1,.52,1.75.33L168,92.49C167.24,93.09,167.14,93.71,167.43,94.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,95.65l1.19,2c.77-.62.9-1.22.61-1.72S171.89,95.44,171.08,95.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.61,87.44a8.88,8.88,0,1,0,12.13,3.25A8.88,8.88,0,0,0,165.61,87.44ZM173,99l.75,1.3-.95.55-.75-1.29a5.84,5.84,0,0,1-3.39.68l-.16-1.47a5.09,5.09,0,0,0,2.83-.46L170,96c-1.46.43-3.08.81-4-.8-.69-1.18-.42-2.71,1.28-3.92l-.75-1.31,1-.55.74,1.28A5.9,5.9,0,0,1,171,90l.2,1.45a5.4,5.4,0,0,0-2.24.46l1.35,2.34c1.47-.43,3.11-.84,4,.77C175,96.21,174.71,97.73,173,99Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,107.32a6.86,6.86,0,1,1-4.78-8.45A6.86,6.86,0,0,1,199.87,107.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,107.32a6.86,6.86,0,1,1-4.78-8.45A6.86,6.86,0,0,1,199.87,107.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,103.83c-.11.41.2.69.66,1l.42-1.52C192.92,103.22,192.58,103.45,192.47,103.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.49,106.21l-.42,1.5c.65.08,1-.14,1.09-.5S194,106.49,193.49,106.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,99.84a5.86,5.86,0,1,0,4.08,7.21A5.85,5.85,0,0,0,194.82,99.84Zm-2,8.8-.26,1-.7-.19.26-1a3.9,3.9,0,0,1-1.89-1.28l.63-.75a3.34,3.34,0,0,0,1.52,1.11l.47-1.7c-.88-.49-1.81-1.07-1.48-2.26a1.92,1.92,0,0,1,2.44-1.21l.27-1,.7.2-.27.94a3.8,3.8,0,0,1,1.59,1l-.59.76a3.67,3.67,0,0,0-1.25-.84l-.48,1.72c.88.49,1.83,1.07,1.5,2.25C195,108.3,194.18,108.87,192.81,108.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11,121.39A4.67,4.67,0,1,1,178,119,4.66,4.66,0,0,1,184.11,121.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11,121.39A4.67,4.67,0,1,1,178,119,4.66,4.66,0,0,1,184.11,121.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.71,122.72c.11.27.4.29.76.24l-.43-1C178.68,122.21,178.6,122.48,178.71,122.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,123.54l.43,1c.38-.24.47-.5.36-.74S180.64,123.49,180.26,123.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.23,119.61a4,4,0,1,0,5.25,2A4,4,0,0,0,178.23,119.61Zm2.72,5.51.27.61-.45.2-.26-.61a2.6,2.6,0,0,1-1.55.13v-.66a2.39,2.39,0,0,0,1.29-.06l-.49-1.1c-.67.11-1.42.2-1.75-.56-.25-.56,0-1.23.77-1.69l-.27-.62.45-.2.27.61a2.43,2.43,0,0,1,1.26-.15l0,.65a2.42,2.42,0,0,0-1,.1l.48,1.11c.68-.12,1.43-.22,1.77.54C182,124,181.78,124.65,181,125.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.08,
    cy: 346.24,
    r: 10.41,
    transform: "translate(-137.75 408.78) rotate(-51.8)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.08,
    cy: 346.24,
    r: 10.41,
    transform: "translate(-137.75 408.78) rotate(-51.8)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.13,343.64c-.23.6.21,1.08.85,1.56l.85-2.22C351.88,342.78,351.34,343.09,351.13,343.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34,347.37l-.84,2.21c1,.21,1.52-.07,1.72-.61S353,347.87,352.34,347.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,337.93a8.88,8.88,0,1,0,5.17,11.45A8.9,8.9,0,0,0,355.22,337.93ZM351,351l-.53,1.4-1-.39.52-1.39a5.83,5.83,0,0,1-2.67-2.19l1-1.06a5.16,5.16,0,0,0,2.15,1.9l.94-2.5c-1.26-.86-2.58-1.88-1.92-3.62.48-1.28,1.83-2,3.85-1.49l.54-1.41,1,.38-.52,1.39a5.73,5.73,0,0,1,2.25,1.73l-1,1.07a5.52,5.52,0,0,0-1.77-1.44l-1,2.52c1.26.87,2.61,1.88,1.95,3.62C354.38,350.74,353,351.49,351,351Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86,369.21a6.86,6.86,0,1,1,3.51-9A6.86,6.86,0,0,1,369.86,369.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86,369.21a6.86,6.86,0,1,1,3.51-9A6.86,6.86,0,0,1,369.86,369.21Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,361.28c-.39.17-.41.6-.34,1.13l1.44-.64C368.62,361.24,368.23,361.12,367.87,361.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.67,363.57l-1.43.63c.35.55.74.68,1.09.53S366.75,364.12,366.67,363.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.45,360.57a5.86,5.86,0,1,0-3,7.72A5.87,5.87,0,0,0,372.45,360.57Zm-8.09,4-.9.4-.29-.66.89-.4a3.84,3.84,0,0,1-.2-2.27h1a3.34,3.34,0,0,0,.1,1.89l1.61-.71c-.18-1-.31-2.09.81-2.58a1.93,1.93,0,0,1,2.49,1.12l.91-.4.29.66-.9.4a3.69,3.69,0,0,1,.23,1.86l-1,0a3.7,3.7,0,0,0-.14-1.5l-1.63.72c.18,1,.33,2.1-.8,2.59C366,366.09,365.05,365.8,364.36,364.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21,369.17a4.67,4.67,0,1,1-5-4.3A4.67,4.67,0,0,1,162.21,369.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21,369.17a4.67,4.67,0,1,1-5-4.3A4.67,4.67,0,0,1,162.21,369.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,368.65c0,.29.29.4.64.48l-.08-1.07C156.81,368.16,156.65,368.39,156.67,368.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.87,369.94,158,371c.44-.1.61-.32.58-.57S158.24,370,157.87,369.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24,365.55a4,4,0,1,0,4.29,3.67A4,4,0,0,0,157.24,365.55Zm.76,6.1.06.68-.49,0-.06-.66a2.64,2.64,0,0,1-1.5-.38l.22-.63a2.2,2.2,0,0,0,1.23.36l-.09-1.2c-.68-.11-1.41-.27-1.47-1.1-.05-.61.35-1.18,1.28-1.34l-.05-.68.49,0,0,.67a2.52,2.52,0,0,1,1.24.27l-.2.62a2.44,2.44,0,0,0-1-.24l.09,1.21c.68.11,1.42.26,1.49,1.09C159.35,370.92,158.94,371.48,158,371.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.06,167.12v3.58l1.84.18a9.56,9.56,0,0,0,1.38,3.3l-1.19,1.43,2.54,2.53,1.43-1.18a9.56,9.56,0,0,0,3.3,1.38l.18,1.84h3.58l.17-1.84A9.61,9.61,0,0,0,405.6,177l1.43,1.18,2.53-2.53-1.18-1.43a9.54,9.54,0,0,0,1.37-3.3l1.85-.18v-3.58l-1.85-.17a9.59,9.59,0,0,0-1.37-3.31l1.18-1.43L407,159.68l-1.43,1.18a9.59,9.59,0,0,0-3.31-1.37l-.17-1.85h-3.58l-.18,1.85a9.54,9.54,0,0,0-3.3,1.37l-1.43-1.18-2.54,2.53,1.19,1.43A9.61,9.61,0,0,0,390.9,167Zm11.27-3.06a4.85,4.85,0,1,1-4.85,4.85A4.85,4.85,0,0,1,400.33,164.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,196.4a8.33,8.33,0,0,0,2.83-1.18l1.22,1,2.17-2.16-1-1.23a8,8,0,0,0,1.18-2.83l1.58-.14V186.8l-1.58-.15a8,8,0,0,0-1.18-2.82l1-1.23-2.17-2.16-1.22,1a8.33,8.33,0,0,0-2.83-1.18l-.15-1.57h-3.06l-.15,1.57a8.25,8.25,0,0,0-2.83,1.18l-1.23-1-2.16,2.16,1,1.23a8.18,8.18,0,0,0-1.17,2.82l-1.58.15v3.07l1.58.14a8.15,8.15,0,0,0,1.17,2.83l-1,1.23,2.16,2.16,1.23-1a8.25,8.25,0,0,0,2.83,1.18l.15,1.57h3.06Zm-5.83-8.07a4.15,4.15,0,1,1,4.15,4.15A4.14,4.14,0,0,1,386.67,188.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.66,177.82l1,.85,1.82-1.82-.85-1a6.82,6.82,0,0,0,1-2.37l1.32-.13v-2.57l-1.32-.13a6.82,6.82,0,0,0-1-2.37l.85-1-1.82-1.82-1,.85a6.82,6.82,0,0,0-2.37-1l-.13-1.32h-2.57l-.13,1.32a6.82,6.82,0,0,0-2.37,1l-1-.85-1.82,1.82.85,1a6.82,6.82,0,0,0-1,2.37l-1.32.13v2.57l1.32.13a6.82,6.82,0,0,0,1,2.37l-.85,1,1.82,1.82,1-.85a7,7,0,0,0,2.37,1l.13,1.32h2.57l.13-1.32A7,7,0,0,0,383.66,177.82ZM376.39,172a3.49,3.49,0,1,1,3.49,3.49A3.48,3.48,0,0,1,376.39,172Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.06,167.12v3.58l1.84.18a9.56,9.56,0,0,0,1.38,3.3l-1.19,1.43,2.54,2.53,1.43-1.18a9.56,9.56,0,0,0,3.3,1.38l.18,1.84h3.58l.17-1.84A9.61,9.61,0,0,0,405.6,177l1.43,1.18,2.53-2.53-1.18-1.43a9.54,9.54,0,0,0,1.37-3.3l1.85-.18v-3.58l-1.85-.17a9.59,9.59,0,0,0-1.37-3.31l1.18-1.43L407,159.68l-1.43,1.18a9.59,9.59,0,0,0-3.31-1.37l-.17-1.85h-3.58l-.18,1.85a9.54,9.54,0,0,0-3.3,1.37l-1.43-1.18-2.54,2.53,1.19,1.43A9.61,9.61,0,0,0,390.9,167Zm11.27-3.06a4.85,4.85,0,1,1-4.85,4.85A4.85,4.85,0,0,1,400.33,164.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,196.4a8.33,8.33,0,0,0,2.83-1.18l1.22,1,2.17-2.16-1-1.23a8,8,0,0,0,1.18-2.83l1.58-.14V186.8l-1.58-.15a8,8,0,0,0-1.18-2.82l1-1.23-2.17-2.16-1.22,1a8.33,8.33,0,0,0-2.83-1.18l-.15-1.57h-3.06l-.15,1.57a8.25,8.25,0,0,0-2.83,1.18l-1.23-1-2.16,2.16,1,1.23a8.18,8.18,0,0,0-1.17,2.82l-1.58.15v3.07l1.58.14a8.15,8.15,0,0,0,1.17,2.83l-1,1.23,2.16,2.16,1.23-1a8.25,8.25,0,0,0,2.83,1.18l.15,1.57h3.06Zm-5.83-8.07a4.15,4.15,0,1,1,4.15,4.15A4.14,4.14,0,0,1,386.67,188.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.66,177.82l1,.85,1.82-1.82-.85-1a6.82,6.82,0,0,0,1-2.37l1.32-.13v-2.57l-1.32-.13a6.82,6.82,0,0,0-1-2.37l.85-1-1.82-1.82-1,.85a6.82,6.82,0,0,0-2.37-1l-.13-1.32h-2.57l-.13,1.32a6.82,6.82,0,0,0-2.37,1l-1-.85-1.82,1.82.85,1a6.82,6.82,0,0,0-1,2.37l-1.32.13v2.57l1.32.13a6.82,6.82,0,0,0,1,2.37l-.85,1,1.82,1.82,1-.85a7,7,0,0,0,2.37,1l.13,1.32h2.57l.13-1.32A7,7,0,0,0,383.66,177.82ZM376.39,172a3.49,3.49,0,1,1,3.49,3.49A3.48,3.48,0,0,1,376.39,172Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.41,254.81l-2.65,2.4,1.1,1.49a9.68,9.68,0,0,0-1.53,3.23l-1.85.09-.18,3.57,1.84.27a9.46,9.46,0,0,0,1.2,3.37l-1.26,1.37,2.41,2.65,1.48-1.1a9.63,9.63,0,0,0,3.24,1.53l.08,1.85,3.58.18.26-1.84a9.56,9.56,0,0,0,3.38-1.19l1.36,1.25,2.66-2.4L117.42,270A9.63,9.63,0,0,0,119,266.8l1.86-.08.18-3.57-1.84-.27a9.58,9.58,0,0,0-1.2-3.38l1.25-1.36-2.4-2.66-1.48,1.11a9.72,9.72,0,0,0-3.24-1.53L112,253.2l-3.58-.17-.27,1.83a9.73,9.73,0,0,0-3.37,1.2Zm9.83,6.31a4.85,4.85,0,1,1-6.85-.35A4.84,4.84,0,0,1,113.24,261.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,258l.06,1.33,2.57.13.19-1.32a6.76,6.76,0,0,0,2.42-.86l1,.9,1.91-1.72-.79-1.07a6.92,6.92,0,0,0,1.1-2.33l1.33-.06.13-2.57-1.32-.19a7,7,0,0,0-.86-2.42l.9-1-1.73-1.91-1.07.8a6.78,6.78,0,0,0-2.32-1.1l-.06-1.34-2.57-.13-.19,1.32a7,7,0,0,0-2.43.86l-1-.89-1.91,1.72.8,1.07a6.78,6.78,0,0,0-1.1,2.32l-1.33.06-.13,2.57,1.32.19a6.81,6.81,0,0,0,.86,2.43l-.9,1,1.73,1.91,1.06-.8A6.74,6.74,0,0,0,91.86,258Zm-.59-9.27a3.48,3.48,0,1,1-.25,4.92A3.48,3.48,0,0,1,91.27,248.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.41,254.81l-2.65,2.4,1.1,1.49a9.68,9.68,0,0,0-1.53,3.23l-1.85.09-.18,3.57,1.84.27a9.46,9.46,0,0,0,1.2,3.37l-1.26,1.37,2.41,2.65,1.48-1.1a9.63,9.63,0,0,0,3.24,1.53l.08,1.85,3.58.18.26-1.84a9.56,9.56,0,0,0,3.38-1.19l1.36,1.25,2.66-2.4L117.42,270A9.63,9.63,0,0,0,119,266.8l1.86-.08.18-3.57-1.84-.27a9.58,9.58,0,0,0-1.2-3.38l1.25-1.36-2.4-2.66-1.48,1.11a9.72,9.72,0,0,0-3.24-1.53L112,253.2l-3.58-.17-.27,1.83a9.73,9.73,0,0,0-3.37,1.2Zm9.83,6.31a4.85,4.85,0,1,1-6.85-.35A4.84,4.84,0,0,1,113.24,261.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,258l.06,1.33,2.57.13.19-1.32a6.76,6.76,0,0,0,2.42-.86l1,.9,1.91-1.72-.79-1.07a6.92,6.92,0,0,0,1.1-2.33l1.33-.06.13-2.57-1.32-.19a7,7,0,0,0-.86-2.42l.9-1-1.73-1.91-1.07.8a6.78,6.78,0,0,0-2.32-1.1l-.06-1.34-2.57-.13-.19,1.32a7,7,0,0,0-2.43.86l-1-.89-1.91,1.72.8,1.07a6.78,6.78,0,0,0-1.1,2.32l-1.33.06-.13,2.57,1.32.19a6.81,6.81,0,0,0,.86,2.43l-.9,1,1.73,1.91,1.06-.8A6.74,6.74,0,0,0,91.86,258Zm-.59-9.27a3.48,3.48,0,1,1-.25,4.92A3.48,3.48,0,0,1,91.27,248.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,113.47l.06,1.34,2.57.13.19-1.32a7,7,0,0,0,2.43-.86l1,.89,1.91-1.72-.8-1.07a6.78,6.78,0,0,0,1.1-2.32l1.33-.06.13-2.57-1.32-.19a6.81,6.81,0,0,0-.86-2.43l.9-1-1.73-1.91-1.06.8a6.74,6.74,0,0,0-2.33-1.1l-.06-1.33-2.57-.13L251,100a6.76,6.76,0,0,0-2.42.86l-1-.9-1.91,1.72.79,1.07a6.92,6.92,0,0,0-1.1,2.33l-1.33.06-.13,2.56,1.32.2a7,7,0,0,0,.86,2.42l-.89,1,1.72,1.91,1.07-.8A6.78,6.78,0,0,0,250.36,113.47Zm-.58-9.27a3.48,3.48,0,1,1-.25,4.92A3.48,3.48,0,0,1,249.78,104.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,113.47l.06,1.34,2.57.13.19-1.32a7,7,0,0,0,2.43-.86l1,.89,1.91-1.72-.8-1.07a6.78,6.78,0,0,0,1.1-2.32l1.33-.06.13-2.57-1.32-.19a6.81,6.81,0,0,0-.86-2.43l.9-1-1.73-1.91-1.06.8a6.74,6.74,0,0,0-2.33-1.1l-.06-1.33-2.57-.13L251,100a6.76,6.76,0,0,0-2.42.86l-1-.9-1.91,1.72.79,1.07a6.92,6.92,0,0,0-1.1,2.33l-1.33.06-.13,2.56,1.32.2a7,7,0,0,0,.86,2.42l-.89,1,1.72,1.91,1.07-.8A6.78,6.78,0,0,0,250.36,113.47Zm-.58-9.27a3.48,3.48,0,1,1-.25,4.92A3.48,3.48,0,0,1,249.78,104.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.25,245.48a21.88,21.88,0,0,1-5.1-.6.61.61,0,0,1-.45-.74.62.62,0,0,1,.74-.45,20.48,20.48,0,0,0,4.81.57,20.75,20.75,0,0,0,15-6.42.59.59,0,0,1,.86,0,.61.61,0,0,1,0,.86A22,22,0,0,1,249.25,245.48ZM235.94,241l.38-.48-.41.46a22,22,0,0,1-6.7-8.59.6.6,0,0,1,.31-.8.61.61,0,0,1,.8.31,20.55,20.55,0,0,0,6.32,8.1l-.32.52Zm30.45-4.13a.62.62,0,0,1-.36-.12.61.61,0,0,1-.13-.85,20.64,20.64,0,0,0,3.84-9.52.62.62,0,0,1,.69-.53.61.61,0,0,1,.52.68,21.89,21.89,0,0,1-4.07,10.09A.61.61,0,0,1,266.39,236.82Zm-37.53-6.62a.62.62,0,0,1-.59-.44,22.22,22.22,0,0,1-.88-6.17A21.72,21.72,0,0,1,232,210.23c.47-.59,1-1.17,1.48-1.72a.61.61,0,0,1,.86,0,.6.6,0,0,1,0,.86,19.6,19.6,0,0,0-1.39,1.63,20.45,20.45,0,0,0-4.31,12.61,21,21,0,0,0,.83,5.83.6.6,0,0,1-.41.75Zm40.8-12a.61.61,0,0,1-.58-.44,20.73,20.73,0,0,0-14.95-14.24.61.61,0,0,1,.28-1.18,21.87,21.87,0,0,1,15.84,15.08.62.62,0,0,1-.42.76Zm-28.49-13.65a.62.62,0,0,1-.57-.38.6.6,0,0,1,.34-.79,21.9,21.9,0,0,1,10.77-1.51.59.59,0,0,1,.53.67.61.61,0,0,1-.67.54,20.68,20.68,0,0,0-10.17,1.42A.68.68,0,0,1,241.17,204.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,205.77a.58.58,0,0,1-.31-.08.61.61,0,0,1-.22-.83l37.16-64.1a.61.61,0,0,1,1,.61l-37.16,64.1A.58.58,0,0,1,259.85,205.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,270.49a.52.52,0,0,1-.24-.05l-87.54-37a.61.61,0,0,1-.32-.8.6.6,0,0,1,.8-.32l87.54,37a.61.61,0,0,1-.24,1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.25,245.48a21.88,21.88,0,0,1-5.1-.6.61.61,0,0,1-.45-.74.62.62,0,0,1,.74-.45,20.48,20.48,0,0,0,4.81.57,20.75,20.75,0,0,0,15-6.42.59.59,0,0,1,.86,0,.61.61,0,0,1,0,.86A22,22,0,0,1,249.25,245.48ZM235.94,241l.38-.48-.41.46a22,22,0,0,1-6.7-8.59.6.6,0,0,1,.31-.8.61.61,0,0,1,.8.31,20.55,20.55,0,0,0,6.32,8.1l-.32.52Zm30.45-4.13a.62.62,0,0,1-.36-.12.61.61,0,0,1-.13-.85,20.64,20.64,0,0,0,3.84-9.52.62.62,0,0,1,.69-.53.61.61,0,0,1,.52.68,21.89,21.89,0,0,1-4.07,10.09A.61.61,0,0,1,266.39,236.82Zm-37.53-6.62a.62.62,0,0,1-.59-.44,22.22,22.22,0,0,1-.88-6.17A21.72,21.72,0,0,1,232,210.23c.47-.59,1-1.17,1.48-1.72a.61.61,0,0,1,.86,0,.6.6,0,0,1,0,.86,19.6,19.6,0,0,0-1.39,1.63,20.45,20.45,0,0,0-4.31,12.61,21,21,0,0,0,.83,5.83.6.6,0,0,1-.41.75Zm40.8-12a.61.61,0,0,1-.58-.44,20.73,20.73,0,0,0-14.95-14.24.61.61,0,0,1,.28-1.18,21.87,21.87,0,0,1,15.84,15.08.62.62,0,0,1-.42.76Zm-28.49-13.65a.62.62,0,0,1-.57-.38.6.6,0,0,1,.34-.79,21.9,21.9,0,0,1,10.77-1.51.59.59,0,0,1,.53.67.61.61,0,0,1-.67.54,20.68,20.68,0,0,0-10.17,1.42A.68.68,0,0,1,241.17,204.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,205.77a.58.58,0,0,1-.31-.08.61.61,0,0,1-.22-.83l37.16-64.1a.61.61,0,0,1,1,.61l-37.16,64.1A.58.58,0,0,1,259.85,205.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,270.49a.52.52,0,0,1-.24-.05l-87.54-37a.61.61,0,0,1-.32-.8.6.6,0,0,1,.8-.32l87.54,37a.61.61,0,0,1-.24,1.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26,214.68a.74.74,0,0,1-.25-.05l-79.79-36.48a.61.61,0,0,1,.51-1.11l79.78,36.48a.61.61,0,0,1-.25,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26,214.68a.74.74,0,0,1-.25-.05l-79.79-36.48a.61.61,0,0,1,.51-1.11l79.78,36.48a.61.61,0,0,1-.25,1.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,309.65a.61.61,0,0,1-.46-.22.59.59,0,0,1,.07-.85l85-72.91a.61.61,0,0,1,.8.92l-85,72.91A.62.62,0,0,1,147.1,309.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,309.65a.61.61,0,0,1-.46-.22.59.59,0,0,1,.07-.85l85-72.91a.61.61,0,0,1,.8.92l-85,72.91A.62.62,0,0,1,147.1,309.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Quality--inject-100"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.59 287.7 397.53 287.84 390.46 305.75 387.8 312.49 382.82 303.46 373.01 306.65 382.8 281.86 389.01 284.32 397.21 287.56 397.59 287.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.87,309.19l-4.27-7.72-8.39,2.72,8.47-21.45,12.66,5Zm-4.11-8.12,4.06,7.35,8.09-20.5-12-4.75-8.09,20.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.53,287.84l-7.07,17.91a60,60,0,0,1-4.62-19.69l3.17-1.74,8.2,3.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.93 312.49 400.91 303.46 410.72 306.65 400.93 281.86 386.14 287.7 395.93 312.49",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.39,287.74l12.65-5,8.47,21.45-8.39-2.72-4.26,7.72ZM408,303.67l-8.09-20.5-12.05,4.75,8.1,20.5,4.06-7.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "391.86 252.62 393.61 251.25 395.09 252.91 397.06 251.88 398.21 253.77 400.33 253.1 401.13 255.18 403.34 254.9 403.76 257.08 405.98 257.2 406 259.42 408.16 259.94 407.78 262.13 409.82 263.02 409.06 265.11 410.9 266.35 409.78 268.27 411.37 269.82 409.92 271.51 411.21 273.32 409.49 274.72 410.43 276.73 408.49 277.8 409.06 279.95 406.95 280.65 407.13 282.87 404.93 283.19 404.71 285.4 402.49 285.32 401.88 287.45 399.71 286.98 398.72 288.97 396.67 288.12 395.35 289.9 393.48 288.7 391.86 290.22 390.24 288.7 388.38 289.9 387.05 288.12 385 288.97 384.02 286.98 381.85 287.45 381.24 285.32 379.02 285.4 378.8 283.19 376.6 282.87 376.78 280.65 374.67 279.95 375.24 277.8 373.3 276.73 374.24 274.72 372.52 273.32 373.8 271.51 372.36 269.82 373.95 268.27 372.83 266.35 374.67 265.11 373.91 263.02 375.94 262.13 375.57 259.94 377.73 259.42 377.75 257.2 379.97 257.08 380.39 254.9 382.59 255.18 383.39 253.1 385.51 253.77 386.67 251.88 388.64 252.91 390.11 251.25 391.86 252.62",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.86 252.62 393.61 251.25 395.09 252.91 397.06 251.88 398.21 253.77 400.33 253.1 401.13 255.18 403.34 254.9 403.76 257.08 405.98 257.2 406 259.42 408.16 259.94 407.78 262.13 409.82 263.02 409.06 265.11 410.9 266.35 409.78 268.27 411.37 269.82 409.92 271.51 411.21 273.32 409.49 274.72 410.43 276.73 408.49 277.8 409.06 279.95 406.95 280.65 407.13 282.87 404.93 283.19 404.71 285.4 402.49 285.32 401.88 287.45 399.71 286.98 398.72 288.97 396.67 288.12 395.35 289.9 393.48 288.7 391.86 290.22 390.24 288.7 388.38 289.9 387.05 288.12 385 288.97 384.02 286.98 381.85 287.45 381.24 285.32 379.02 285.4 378.8 283.19 376.6 282.87 376.78 280.65 374.67 279.95 375.24 277.8 373.3 276.73 374.24 274.72 372.52 273.32 373.8 271.51 372.36 269.82 373.95 268.27 372.83 266.35 374.67 265.11 373.91 263.02 375.94 262.13 375.57 259.94 377.73 259.42 377.75 257.2 379.97 257.08 380.39 254.9 382.59 255.18 383.39 253.1 385.51 253.77 386.67 251.88 388.64 252.91 390.11 251.25 391.86 252.62",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.86,
    cy: 270.73,
    r: 16.79,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,270.73s1.35-2.84,3.1-3c3.36-.33,6.8,6.79,6.8,6.79s3.61-8.11,11.06-11.73c0,0-4.32,4.15-8,15.1-.29.84-4.22,2-5.14,1.51S385.48,271.57,381.79,270.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.62,314.77a.61.61,0,0,1-.61-.61.61.61,0,0,1,.61-.61,35.17,35.17,0,0,0,17.53-4.7.6.6,0,1,1,.6,1,36.27,36.27,0,0,1-18.13,4.87Zm-7.41-.77h-.13a36.57,36.57,0,0,1-8.59-3,.61.61,0,0,1,.54-1.1,34.75,34.75,0,0,0,8.3,2.88.61.61,0,0,1,.47.72A.6.6,0,0,1,383.21,314Zm-10.42-4a.68.68,0,0,1-.31-.08,36.67,36.67,0,0,1-13.3-13.25.61.61,0,0,1,1.06-.62,34.75,34.75,0,0,0,6.9,8.49,35.26,35.26,0,0,0,5.95,4.32.61.61,0,0,1,.22.83A.59.59,0,0,1,372.79,310Zm37.56-1.22a.61.61,0,0,1-.5-.27.62.62,0,0,1,.16-.85,35.33,35.33,0,0,0,6.65-5.75l.06-.08a.61.61,0,0,1,.86-.05.6.6,0,0,1,.05.86l-.07.08a36.41,36.41,0,0,1-6.87,6A.67.67,0,0,1,410.35,308.8Zm11.19-12a.56.56,0,0,1-.3-.08.6.6,0,0,1-.22-.83,35.07,35.07,0,0,0,4.63-17.41v-.13a.61.61,0,1,1,1.21,0v.13a36.18,36.18,0,0,1-4.79,18A.6.6,0,0,1,421.54,296.82Zm-64.87-6.64a.6.6,0,0,1-.58-.42,36.08,36.08,0,0,1-1.71-8.93.61.61,0,1,1,1.21-.07,35.16,35.16,0,0,0,1.66,8.62.61.61,0,0,1-.39.77A.63.63,0,0,1,356.67,290.18Zm-1.76-11.06a.57.57,0,0,1-.61-.57v-.07a36.26,36.26,0,0,1,4.82-18.07.61.61,0,1,1,1.05.61,35.07,35.07,0,0,0-4.65,17.46A.64.64,0,0,1,354.91,279.12Zm71.27-2.38a.61.61,0,0,1-.61-.57,35.63,35.63,0,0,0-1.67-8.63.59.59,0,0,1,.39-.76.6.6,0,0,1,.77.38,36.65,36.65,0,0,1,1.72,8.93.61.61,0,0,1-.56.65Zm-4.75-15.58a.62.62,0,0,1-.53-.3A35.23,35.23,0,0,0,408,248.07a.63.63,0,0,1-.23-.84.62.62,0,0,1,.84-.22,36.7,36.7,0,0,1,6.2,4.5,36,36,0,0,1,7.11,8.74.61.61,0,0,1-.22.83A.64.64,0,0,1,421.43,261.16Zm-56.92-6.11-.49-.37-.43-.44a36.7,36.7,0,0,1,6.84-5.93.61.61,0,0,1,.68,1A35.29,35.29,0,0,0,364.51,255.05Zm-.49-.37h0Zm8.65-6.44a.62.62,0,0,1-.53-.31.61.61,0,0,1,.22-.83,36.42,36.42,0,0,1,18.13-4.89h0a.61.61,0,1,1,0,1.21A35.14,35.14,0,0,0,373,248.16.64.64,0,0,1,372.67,248.24Zm33.69-1.15a.63.63,0,0,1-.27-.06,34.78,34.78,0,0,0-8.31-2.86.61.61,0,0,1-.47-.72A.62.62,0,0,1,398,243a36.35,36.35,0,0,1,8.6,3,.6.6,0,0,1,.27.81A.59.59,0,0,1,406.36,247.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.62,314.77a.61.61,0,0,1-.61-.61.61.61,0,0,1,.61-.61,35.17,35.17,0,0,0,17.53-4.7.6.6,0,1,1,.6,1,36.27,36.27,0,0,1-18.13,4.87Zm-7.41-.77h-.13a36.57,36.57,0,0,1-8.59-3,.61.61,0,0,1,.54-1.1,34.75,34.75,0,0,0,8.3,2.88.61.61,0,0,1,.47.72A.6.6,0,0,1,383.21,314Zm-10.42-4a.68.68,0,0,1-.31-.08,36.67,36.67,0,0,1-13.3-13.25.61.61,0,0,1,1.06-.62,34.75,34.75,0,0,0,6.9,8.49,35.26,35.26,0,0,0,5.95,4.32.61.61,0,0,1,.22.83A.59.59,0,0,1,372.79,310Zm37.56-1.22a.61.61,0,0,1-.5-.27.62.62,0,0,1,.16-.85,35.33,35.33,0,0,0,6.65-5.75l.06-.08a.61.61,0,0,1,.86-.05.6.6,0,0,1,.05.86l-.07.08a36.41,36.41,0,0,1-6.87,6A.67.67,0,0,1,410.35,308.8Zm11.19-12a.56.56,0,0,1-.3-.08.6.6,0,0,1-.22-.83,35.07,35.07,0,0,0,4.63-17.41v-.13a.61.61,0,1,1,1.21,0v.13a36.18,36.18,0,0,1-4.79,18A.6.6,0,0,1,421.54,296.82Zm-64.87-6.64a.6.6,0,0,1-.58-.42,36.08,36.08,0,0,1-1.71-8.93.61.61,0,1,1,1.21-.07,35.16,35.16,0,0,0,1.66,8.62.61.61,0,0,1-.39.77A.63.63,0,0,1,356.67,290.18Zm-1.76-11.06a.57.57,0,0,1-.61-.57v-.07a36.26,36.26,0,0,1,4.82-18.07.61.61,0,1,1,1.05.61,35.07,35.07,0,0,0-4.65,17.46A.64.64,0,0,1,354.91,279.12Zm71.27-2.38a.61.61,0,0,1-.61-.57,35.63,35.63,0,0,0-1.67-8.63.59.59,0,0,1,.39-.76.6.6,0,0,1,.77.38,36.65,36.65,0,0,1,1.72,8.93.61.61,0,0,1-.56.65Zm-4.75-15.58a.62.62,0,0,1-.53-.3A35.23,35.23,0,0,0,408,248.07a.63.63,0,0,1-.23-.84.62.62,0,0,1,.84-.22,36.7,36.7,0,0,1,6.2,4.5,36,36,0,0,1,7.11,8.74.61.61,0,0,1-.22.83A.64.64,0,0,1,421.43,261.16Zm-56.92-6.11-.49-.37-.43-.44a36.7,36.7,0,0,1,6.84-5.93.61.61,0,0,1,.68,1A35.29,35.29,0,0,0,364.51,255.05Zm-.49-.37h0Zm8.65-6.44a.62.62,0,0,1-.53-.31.61.61,0,0,1,.22-.83,36.42,36.42,0,0,1,18.13-4.89h0a.61.61,0,1,1,0,1.21A35.14,35.14,0,0,0,373,248.16.64.64,0,0,1,372.67,248.24Zm33.69-1.15a.63.63,0,0,1-.27-.06,34.78,34.78,0,0,0-8.31-2.86.61.61,0,0,1-.47-.72A.62.62,0,0,1,398,243a36.35,36.35,0,0,1,8.6,3,.6.6,0,0,1,.27.81A.59.59,0,0,1,406.36,247.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Improvement--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.53,123.06h5.16a1.28,1.28,0,0,1,1.28,1.28v2.54a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0v-2.54A1.28,1.28,0,0,1,291.53,123.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94,111.34h5.16a1.28,1.28,0,0,1,1.28,1.28v14.26a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V112.62A1.28,1.28,0,0,1,302.94,111.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,113.88h5.16a1.28,1.28,0,0,1,1.28,1.28v11.71a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V115.17A1.28,1.28,0,0,1,314.36,113.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,100.89h5.16a1.28,1.28,0,0,1,1.28,1.28v24.71a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V102.17A1.28,1.28,0,0,1,325.77,100.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 82.64 330.25 83.34 327.32 84.36 328.75 85.43 314.78 104.7 302.43 99.16 287.08 116.89 290.08 119.34 303.47 103.86 316.07 109.5 331.85 87.72 333.1 88.66 333.37 82.26 332.25 82.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,123.06h5.16a1.28,1.28,0,0,1,1.28,1.28v2.54a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0v-2.54A1.28,1.28,0,0,1,291.53,123.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94,111.34h5.16a1.28,1.28,0,0,1,1.28,1.28v14.26a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V112.62A1.28,1.28,0,0,1,302.94,111.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,113.88h5.16a1.28,1.28,0,0,1,1.28,1.28v11.71a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V115.17A1.28,1.28,0,0,1,314.36,113.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,100.89h5.16a1.28,1.28,0,0,1,1.28,1.28v24.71a0,0,0,0,1,0,0h-7.73a0,0,0,0,1,0,0V102.17A1.28,1.28,0,0,1,325.77,100.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 82.64 330.25 83.34 327.32 84.36 328.75 85.43 314.78 104.7 302.43 99.16 287.08 116.89 290.08 119.34 303.47 103.86 316.07 109.5 331.85 87.72 333.1 88.66 333.37 82.26 332.25 82.64",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37,129.17H288.76a1.15,1.15,0,0,1-1.15-1.14h0a1.15,1.15,0,0,1,1.15-1.15h45.61a1.14,1.14,0,0,1,1.14,1.15h0A1.14,1.14,0,0,1,334.37,129.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37,129.17H288.76a1.15,1.15,0,0,1-1.15-1.14h0a1.15,1.15,0,0,1,1.15-1.15h45.61a1.14,1.14,0,0,1,1.14,1.15h0A1.14,1.14,0,0,1,334.37,129.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,145.58a36.08,36.08,0,0,1-7.95-.89.61.61,0,1,1,.27-1.18,35.13,35.13,0,0,0,8.74.84.57.57,0,0,1,.63.59.6.6,0,0,1-.59.62C313.93,145.58,313.57,145.58,313.2,145.58Zm3.32-.15a.61.61,0,0,1-.06-1.22,35.59,35.59,0,0,0,7.21-1.45,35.22,35.22,0,0,0,9.81-4.85.61.61,0,0,1,.85.15.6.6,0,0,1-.15.84,36.33,36.33,0,0,1-17.6,6.52Zm-18.19-3.11a.58.58,0,0,1-.26-.06,36.37,36.37,0,0,1-14.46-12,.61.61,0,0,1,.15-.85.6.6,0,0,1,.84.15,35.21,35.21,0,0,0,14,11.57.61.61,0,0,1-.25,1.16Zm41.1-8.23a.59.59,0,0,1-.41-.16.6.6,0,0,1,0-.86,35,35,0,0,0,5.1-7.16.61.61,0,0,1,.82-.24.6.6,0,0,1,.25.82,36.39,36.39,0,0,1-5.27,7.41A.61.61,0,0,1,339.43,134.09Zm-56.56-5.41a.61.61,0,0,1-.52-.29,36.38,36.38,0,0,1-3.77-8.27l0-.1a.61.61,0,0,1,.4-.77.61.61,0,0,1,.76.4l0,.11a35.21,35.21,0,0,0,3.65,8,.61.61,0,0,1-.2.84A.62.62,0,0,1,282.87,128.68Zm62.75-3.87a.58.58,0,0,1-.26-.06.62.62,0,0,1-.3-.81,35.16,35.16,0,0,0,3.22-14.64c0-1.07,0-2.17-.15-3.24a.61.61,0,0,1,.55-.66.59.59,0,0,1,.66.55c.1,1.11.16,2.24.16,3.35a36.45,36.45,0,0,1-3.33,15.15A.61.61,0,0,1,345.62,124.81Zm-67.95-11.68a.61.61,0,0,1-.6-.55c-.1-1.1-.15-2.21-.15-3.3a36.51,36.51,0,0,1,3.35-15.2.61.61,0,1,1,1.1.51,35.28,35.28,0,0,0-3.24,14.69c0,1.06.05,2.13.15,3.19a.61.61,0,0,1-.55.66Zm69-14.26.58-.17-.6.13a34.83,34.83,0,0,0-3.61-8,.61.61,0,0,1,.19-.84.6.6,0,0,1,.84.2,35.92,35.92,0,0,1,3.74,8.22l-.56.24Zm-64.87-5.93a.58.58,0,0,1-.28-.07.61.61,0,0,1-.25-.83,36.42,36.42,0,0,1,5.28-7.39.61.61,0,0,1,.86,0,.6.6,0,0,1,0,.86,35.4,35.4,0,0,0-5.11,7.15A.6.6,0,0,1,281.82,92.94Zm60.52-3.65a.6.6,0,0,1-.5-.25,35.13,35.13,0,0,0-14-11.59.61.61,0,1,1,.51-1.11,36.37,36.37,0,0,1,14.44,12,.61.61,0,0,1-.14.85A.58.58,0,0,1,342.34,89.29Zm-49.71-8.54a.61.61,0,0,1-.5-.26.6.6,0,0,1,.14-.84,36.25,36.25,0,0,1,10.11-5,36.61,36.61,0,0,1,7.51-1.5.61.61,0,1,1,.12,1.21,35.33,35.33,0,0,0-17,6.27A.58.58,0,0,1,292.63,80.75Zm28.45-5.65H321a35.23,35.23,0,0,0-8.75-.86.59.59,0,0,1-.62-.59.6.6,0,0,1,.59-.62,35.79,35.79,0,0,1,9.05.88.61.61,0,0,1-.14,1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,145.58a36.08,36.08,0,0,1-7.95-.89.61.61,0,1,1,.27-1.18,35.13,35.13,0,0,0,8.74.84.57.57,0,0,1,.63.59.6.6,0,0,1-.59.62C313.93,145.58,313.57,145.58,313.2,145.58Zm3.32-.15a.61.61,0,0,1-.06-1.22,35.59,35.59,0,0,0,7.21-1.45,35.22,35.22,0,0,0,9.81-4.85.61.61,0,0,1,.85.15.6.6,0,0,1-.15.84,36.33,36.33,0,0,1-17.6,6.52Zm-18.19-3.11a.58.58,0,0,1-.26-.06,36.37,36.37,0,0,1-14.46-12,.61.61,0,0,1,.15-.85.6.6,0,0,1,.84.15,35.21,35.21,0,0,0,14,11.57.61.61,0,0,1-.25,1.16Zm41.1-8.23a.59.59,0,0,1-.41-.16.6.6,0,0,1,0-.86,35,35,0,0,0,5.1-7.16.61.61,0,0,1,.82-.24.6.6,0,0,1,.25.82,36.39,36.39,0,0,1-5.27,7.41A.61.61,0,0,1,339.43,134.09Zm-56.56-5.41a.61.61,0,0,1-.52-.29,36.38,36.38,0,0,1-3.77-8.27l0-.1a.61.61,0,0,1,.4-.77.61.61,0,0,1,.76.4l0,.11a35.21,35.21,0,0,0,3.65,8,.61.61,0,0,1-.2.84A.62.62,0,0,1,282.87,128.68Zm62.75-3.87a.58.58,0,0,1-.26-.06.62.62,0,0,1-.3-.81,35.16,35.16,0,0,0,3.22-14.64c0-1.07,0-2.17-.15-3.24a.61.61,0,0,1,.55-.66.59.59,0,0,1,.66.55c.1,1.11.16,2.24.16,3.35a36.45,36.45,0,0,1-3.33,15.15A.61.61,0,0,1,345.62,124.81Zm-67.95-11.68a.61.61,0,0,1-.6-.55c-.1-1.1-.15-2.21-.15-3.3a36.51,36.51,0,0,1,3.35-15.2.61.61,0,1,1,1.1.51,35.28,35.28,0,0,0-3.24,14.69c0,1.06.05,2.13.15,3.19a.61.61,0,0,1-.55.66Zm69-14.26.58-.17-.6.13a34.83,34.83,0,0,0-3.61-8,.61.61,0,0,1,.19-.84.6.6,0,0,1,.84.2,35.92,35.92,0,0,1,3.74,8.22l-.56.24Zm-64.87-5.93a.58.58,0,0,1-.28-.07.61.61,0,0,1-.25-.83,36.42,36.42,0,0,1,5.28-7.39.61.61,0,0,1,.86,0,.6.6,0,0,1,0,.86,35.4,35.4,0,0,0-5.11,7.15A.6.6,0,0,1,281.82,92.94Zm60.52-3.65a.6.6,0,0,1-.5-.25,35.13,35.13,0,0,0-14-11.59.61.61,0,1,1,.51-1.11,36.37,36.37,0,0,1,14.44,12,.61.61,0,0,1-.14.85A.58.58,0,0,1,342.34,89.29Zm-49.71-8.54a.61.61,0,0,1-.5-.26.6.6,0,0,1,.14-.84,36.25,36.25,0,0,1,10.11-5,36.61,36.61,0,0,1,7.51-1.5.61.61,0,1,1,.12,1.21,35.33,35.33,0,0,0-17,6.27A.58.58,0,0,1,292.63,80.75Zm28.45-5.65H321a35.23,35.23,0,0,0-8.75-.86.59.59,0,0,1-.62-.59.6.6,0,0,1,.59-.62,35.79,35.79,0,0,1,9.05.88.61.61,0,0,1-.14,1.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Promotion--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109,163.49c-2.29-4.08-6.72-5.94-9.91-4.16s-3.93,6.54-1.64,10.62,6.72,6,9.91,4.17S111.28,167.58,109,163.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,149.18l-7.85-14.44s-5.48,11.77-13.37,16.18l4,7.15.63,1.13,4,7.16c7.88-4.4,20.78-2.92,20.78-2.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,163.49c-2.29-4.08-6.72-5.94-9.91-4.16s-3.93,6.54-1.64,10.62,6.72,6,9.91,4.17S111.28,167.58,109,163.49Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,149.18l-7.85-14.44s-5.48,11.77-13.37,16.18l4,7.15.63,1.13,4,7.16c7.88-4.4,20.78-2.92,20.78-2.92Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,172s5.68,8.22,11,11.23a.89.89,0,0,0,1.12-.24l4.52-5.61a.9.9,0,0,0-.33-1.37c-2.24-1-7.45-3.52-10.45-7.07C110.39,164.28,108.46,172,108.46,172Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,172s5.68,8.22,11,11.23a.89.89,0,0,0,1.12-.24l4.52-5.61a.9.9,0,0,0-.33-1.37c-2.24-1-7.45-3.52-10.45-7.07C110.39,164.28,108.46,172,108.46,172Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,163.86c-1.81,1-6.94-4.72-11.45-12.8s-6.72-15.45-4.91-16.46,6.93,4.72,11.45,12.8S144.85,162.84,143,163.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,161.47c-1.35.76-5.35-3.75-9.12-10.23-.22-.37-.43-.75-.65-1.13s-.51-.92-.74-1.36c-3.47-6.54-5.17-12.18-3.83-12.93s5.83,4.28,9.79,11.37S143.74,160.67,142.3,161.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.62,175.62s-1.94-1.38-5.46-7.67c-3.8-6.81-3.7-8.72-3.7-8.72l17.61-9.84s.21,2.47,3.78,8.86,5.38,7.52,5.38,7.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,151.24c-.22-.37-.43-.75-.65-1.13s-.51-.92-.74-1.36l1.82-.58a.85.85,0,0,1,1,.46l.14.26a.85.85,0,0,1-.13,1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,151.24c-.22-.37-.43-.75-.65-1.13s-.51-.92-.74-1.36l1.82-.58a.85.85,0,0,1,1,.46l.14.26a.85.85,0,0,1-.13,1.1Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.93,195.5a36.17,36.17,0,0,1-12.35-2.16.6.6,0,0,1-.36-.78.6.6,0,0,1,.77-.36,35.24,35.24,0,0,0,18.08,1.54.61.61,0,1,1,.22,1.2A36.59,36.59,0,0,1,119.93,195.5Zm8.44-1a.61.61,0,0,1-.14-1.2,34.89,34.89,0,0,0,8.2-3.14l.11-.06a.61.61,0,0,1,.57,1.07l-.1.06a37,37,0,0,1-8.49,3.26Zm-27.29-4.34a.55.55,0,0,1-.32-.1,35.73,35.73,0,0,1-7.07-5.72.61.61,0,1,1,.88-.84A35,35,0,0,0,101.4,189a.61.61,0,0,1-.32,1.13ZM143,187a.58.58,0,0,1-.46-.22.59.59,0,0,1,.07-.85A35.13,35.13,0,0,0,152.91,171a.61.61,0,1,1,1.14.41,36.18,36.18,0,0,1-10.67,15.43A.62.62,0,0,1,143,187Zm-50.34-4.19a.61.61,0,0,1-.47-.21,36.55,36.55,0,0,1-8-17,.61.61,0,1,1,1.2-.22,35.36,35.36,0,0,0,7.72,16.42.61.61,0,0,1-.07.86A.59.59,0,0,1,92.64,182.84Zm61.53-13.12a.51.51,0,0,1-.17,0,.61.61,0,0,1-.42-.75,35.08,35.08,0,0,0,1.37-8.68.59.59,0,0,1,.63-.59.61.61,0,0,1,.59.63,36.57,36.57,0,0,1-1.42,9A.61.61,0,0,1,154.17,169.72Zm-69.93-11h0a.61.61,0,0,1-.59-.63,36.43,36.43,0,0,1,1.43-9,.6.6,0,1,1,1.16.34,35.41,35.41,0,0,0-1.38,8.67A.61.61,0,0,1,84.24,158.7ZM155,153.45a.6.6,0,0,1-.59-.5,35.07,35.07,0,0,0-3.59-10.27,35.87,35.87,0,0,0-4.17-6.14.6.6,0,0,1,.08-.85.59.59,0,0,1,.85.07,36.47,36.47,0,0,1,8,17,.61.61,0,0,1-.49.71Zm-68.67-5.71a.64.64,0,0,1-.2,0,.61.61,0,0,1-.37-.78,36.3,36.3,0,0,1,10.7-15.42.61.61,0,0,1,.79.93,35.13,35.13,0,0,0-10.35,14.9A.59.59,0,0,1,86.33,147.74Zm59.29-12.64a.63.63,0,0,1-.44-.19,34.94,34.94,0,0,0-6.83-5.52.6.6,0,0,1-.2-.84.61.61,0,0,1,.84-.19,36,36,0,0,1,7.07,5.71.61.61,0,0,1,0,.86A.63.63,0,0,1,145.62,135.1Zm-42.56-6.73a.62.62,0,0,1-.55-.31.59.59,0,0,1,.22-.81l.29.54-.24-.56a36.1,36.1,0,0,1,8.44-3.25.61.61,0,0,1,.29,1.18,35.13,35.13,0,0,0-8.15,3.14A.63.63,0,0,1,103.06,128.37ZM132,126.25a.52.52,0,0,1-.21,0,35.22,35.22,0,0,0-18.08-1.51.61.61,0,0,1-.71-.49.62.62,0,0,1,.5-.71,36.42,36.42,0,0,1,18.7,1.57.61.61,0,0,1-.2,1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.93,195.5a36.17,36.17,0,0,1-12.35-2.16.6.6,0,0,1-.36-.78.6.6,0,0,1,.77-.36,35.24,35.24,0,0,0,18.08,1.54.61.61,0,1,1,.22,1.2A36.59,36.59,0,0,1,119.93,195.5Zm8.44-1a.61.61,0,0,1-.14-1.2,34.89,34.89,0,0,0,8.2-3.14l.11-.06a.61.61,0,0,1,.57,1.07l-.1.06a37,37,0,0,1-8.49,3.26Zm-27.29-4.34a.55.55,0,0,1-.32-.1,35.73,35.73,0,0,1-7.07-5.72.61.61,0,1,1,.88-.84A35,35,0,0,0,101.4,189a.61.61,0,0,1-.32,1.13ZM143,187a.58.58,0,0,1-.46-.22.59.59,0,0,1,.07-.85A35.13,35.13,0,0,0,152.91,171a.61.61,0,1,1,1.14.41,36.18,36.18,0,0,1-10.67,15.43A.62.62,0,0,1,143,187Zm-50.34-4.19a.61.61,0,0,1-.47-.21,36.55,36.55,0,0,1-8-17,.61.61,0,1,1,1.2-.22,35.36,35.36,0,0,0,7.72,16.42.61.61,0,0,1-.07.86A.59.59,0,0,1,92.64,182.84Zm61.53-13.12a.51.51,0,0,1-.17,0,.61.61,0,0,1-.42-.75,35.08,35.08,0,0,0,1.37-8.68.59.59,0,0,1,.63-.59.61.61,0,0,1,.59.63,36.57,36.57,0,0,1-1.42,9A.61.61,0,0,1,154.17,169.72Zm-69.93-11h0a.61.61,0,0,1-.59-.63,36.43,36.43,0,0,1,1.43-9,.6.6,0,1,1,1.16.34,35.41,35.41,0,0,0-1.38,8.67A.61.61,0,0,1,84.24,158.7ZM155,153.45a.6.6,0,0,1-.59-.5,35.07,35.07,0,0,0-3.59-10.27,35.87,35.87,0,0,0-4.17-6.14.6.6,0,0,1,.08-.85.59.59,0,0,1,.85.07,36.47,36.47,0,0,1,8,17,.61.61,0,0,1-.49.71Zm-68.67-5.71a.64.64,0,0,1-.2,0,.61.61,0,0,1-.37-.78,36.3,36.3,0,0,1,10.7-15.42.61.61,0,0,1,.79.93,35.13,35.13,0,0,0-10.35,14.9A.59.59,0,0,1,86.33,147.74Zm59.29-12.64a.63.63,0,0,1-.44-.19,34.94,34.94,0,0,0-6.83-5.52.6.6,0,0,1-.2-.84.61.61,0,0,1,.84-.19,36,36,0,0,1,7.07,5.71.61.61,0,0,1,0,.86A.63.63,0,0,1,145.62,135.1Zm-42.56-6.73a.62.62,0,0,1-.55-.31.59.59,0,0,1,.22-.81l.29.54-.24-.56a36.1,36.1,0,0,1,8.44-3.25.61.61,0,0,1,.29,1.18,35.13,35.13,0,0,0-8.15,3.14A.63.63,0,0,1,103.06,128.37ZM132,126.25a.52.52,0,0,1-.21,0,35.22,35.22,0,0,0-18.08-1.51.61.61,0,0,1-.71-.49.62.62,0,0,1,.5-.71,36.42,36.42,0,0,1,18.7,1.57.61.61,0,0,1-.2,1.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Support--inject-100"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.57,
    y: 336.38,
    width: 20.64,
    height: 8.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.57,
    y: 336.38,
    width: 20.64,
    height: 8.97,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,337.29s-5.08-7.11-5.08-10.83,3-5.75,5.08-4.4c0,0-1-7.17,0-9.67s6.09-1,6.09-1a4.26,4.26,0,0,1,3.89-2.35,4.64,4.64,0,0,1,4.06,2.35,4.46,4.46,0,0,1,4.23-1c2.71.66,2.37,2.13,2.37,2.13s3.89,0,4.74,1.21,2.54,17.28-1,22.36S114.58,342.87,109.17,337.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,327.21c-.18,3.59-.77,7-2.09,8.89-3.56,5.08-18.95,6.77-24.37,1.19,0,0-5.08-7.11-5.08-10.83s3.06-5.75,5.08-4.4c0,0-1-7.17,0-9.67s6.1-1,6.1-1a4.24,4.24,0,0,1,3.89-2.33,4.64,4.64,0,0,1,4,2.33,4.42,4.42,0,0,1,4.23-1c2.71.65,2.37,2.11,2.37,2.11s3.9,0,4.74,1.21C135.08,314.5,136,321.12,135.63,327.21Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,327.21c-.45-.18-2.85-1.1-3.53.24s-7.11,7.79-9.52,5.38-9.37-4.7-9.37-4.7a5.87,5.87,0,0,0,2.89-.76c2.93-1.65,2.42-4.19.85-4.07-.39,0-7.78-1.24-7.78-1.24s5.42-.15,6-.91.12-7.48.64-7.35.24,6.85.37,8,4.85,1.2,5.48.56.47-9.22,1.38-8.65-.53,8.85.38,9.35,2.88,1,3.74.49,1.64-9.29,2.15-8.91-.19,8.28.07,8.91,1.77.66,2.92.4,2.2-10.21,2.2-10.21C135.08,314.5,136,321.12,135.63,327.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.57,342.72s10.18,3.18,20.64,0l1.41.71v11a88.48,88.48,0,0,1-23.6,0l.7-10.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85,368.4c-.66,0-1.32,0-2-.06a.61.61,0,0,1-.58-.64.6.6,0,0,1,.64-.57,35.57,35.57,0,0,0,17.77-3.71.61.61,0,0,1,.55,1.08A36.17,36.17,0,0,1,125.48,368,36.72,36.72,0,0,1,119.85,368.4Zm-4.17-.25h-.08a36.43,36.43,0,0,1-8.82-2.2.62.62,0,0,1-.34-.79.61.61,0,0,1,.79-.35,34.78,34.78,0,0,0,8.52,2.13.61.61,0,0,1,.53.67A.61.61,0,0,1,115.68,368.15Zm-15.3-5.57a.61.61,0,0,1-.34-.1,36.4,36.4,0,0,1-12.52-14,.61.61,0,0,1,.27-.82.6.6,0,0,1,.81.27,35.17,35.17,0,0,0,12.11,13.51.61.61,0,0,1-.33,1.12Zm41.87-2.05a.62.62,0,0,1-.48-.23.6.6,0,0,1,.1-.85,35.52,35.52,0,0,0,6.1-6.33.61.61,0,0,1,1,.73,36.2,36.2,0,0,1-6.31,6.54A.62.62,0,0,1,142.25,360.53Zm7.49-8.27a.56.56,0,0,1-.33-.1.6.6,0,0,1-.18-.84,35,35,0,0,0,5.68-17.23.61.61,0,0,1,1.22.07A36.38,36.38,0,0,1,150.25,352,.6.6,0,0,1,149.74,352.26ZM87.11,346.8a.62.62,0,0,1-.56-.37,36.53,36.53,0,0,1-2.5-8.73l0-.13a.61.61,0,0,1,.51-.69.6.6,0,0,1,.69.51l0,.12A35.5,35.5,0,0,0,87.67,346a.61.61,0,0,1-.32.8A.52.52,0,0,1,87.11,346.8Zm-2.83-16.16h0a.61.61,0,0,1-.57-.64,36.27,36.27,0,0,1,5.91-17.82.6.6,0,0,1,.84-.17.61.61,0,0,1,.18.84,35,35,0,0,0-5.71,17.22A.61.61,0,0,1,84.28,330.64Zm70.27-3.87.6-.09-.61.05a35.09,35.09,0,0,0-2.4-8.41.61.61,0,0,1,1.12-.48,36.23,36.23,0,0,1,2.48,8.68l-.59.16Zm-2.79-10.11a.6.6,0,0,1-.54-.33,35.19,35.19,0,0,0-12.09-13.54.61.61,0,0,1,.67-1,36.25,36.25,0,0,1,12.5,14,.6.6,0,0,1-.27.82A.63.63,0,0,1,151.76,316.66Zm-60.38-5.37a.63.63,0,0,1-.37-.12.61.61,0,0,1-.12-.85,36.54,36.54,0,0,1,6.32-6.53.61.61,0,1,1,.77.95,35.17,35.17,0,0,0-6.12,6.31A.6.6,0,0,1,91.38,311.29Zm12.49-10.45a.61.61,0,0,1-.28-1.15,36.42,36.42,0,0,1,10.72-3.43,37.27,37.27,0,0,1,7.67-.38.61.61,0,0,1,.57.64.59.59,0,0,1-.64.58,35.38,35.38,0,0,0-17.77,3.68A.66.66,0,0,1,103.87,300.84Zm29-1.37a.6.6,0,0,1-.22,0,34.8,34.8,0,0,0-8.52-2.14.61.61,0,0,1,.15-1.21,36,36,0,0,1,8.82,2.22.61.61,0,0,1,.34.79A.6.6,0,0,1,132.84,299.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85,368.4c-.66,0-1.32,0-2-.06a.61.61,0,0,1-.58-.64.6.6,0,0,1,.64-.57,35.57,35.57,0,0,0,17.77-3.71.61.61,0,0,1,.55,1.08A36.17,36.17,0,0,1,125.48,368,36.72,36.72,0,0,1,119.85,368.4Zm-4.17-.25h-.08a36.43,36.43,0,0,1-8.82-2.2.62.62,0,0,1-.34-.79.61.61,0,0,1,.79-.35,34.78,34.78,0,0,0,8.52,2.13.61.61,0,0,1,.53.67A.61.61,0,0,1,115.68,368.15Zm-15.3-5.57a.61.61,0,0,1-.34-.1,36.4,36.4,0,0,1-12.52-14,.61.61,0,0,1,.27-.82.6.6,0,0,1,.81.27,35.17,35.17,0,0,0,12.11,13.51.61.61,0,0,1-.33,1.12Zm41.87-2.05a.62.62,0,0,1-.48-.23.6.6,0,0,1,.1-.85,35.52,35.52,0,0,0,6.1-6.33.61.61,0,0,1,1,.73,36.2,36.2,0,0,1-6.31,6.54A.62.62,0,0,1,142.25,360.53Zm7.49-8.27a.56.56,0,0,1-.33-.1.6.6,0,0,1-.18-.84,35,35,0,0,0,5.68-17.23.61.61,0,0,1,1.22.07A36.38,36.38,0,0,1,150.25,352,.6.6,0,0,1,149.74,352.26ZM87.11,346.8a.62.62,0,0,1-.56-.37,36.53,36.53,0,0,1-2.5-8.73l0-.13a.61.61,0,0,1,.51-.69.6.6,0,0,1,.69.51l0,.12A35.5,35.5,0,0,0,87.67,346a.61.61,0,0,1-.32.8A.52.52,0,0,1,87.11,346.8Zm-2.83-16.16h0a.61.61,0,0,1-.57-.64,36.27,36.27,0,0,1,5.91-17.82.6.6,0,0,1,.84-.17.61.61,0,0,1,.18.84,35,35,0,0,0-5.71,17.22A.61.61,0,0,1,84.28,330.64Zm70.27-3.87.6-.09-.61.05a35.09,35.09,0,0,0-2.4-8.41.61.61,0,0,1,1.12-.48,36.23,36.23,0,0,1,2.48,8.68l-.59.16Zm-2.79-10.11a.6.6,0,0,1-.54-.33,35.19,35.19,0,0,0-12.09-13.54.61.61,0,0,1,.67-1,36.25,36.25,0,0,1,12.5,14,.6.6,0,0,1-.27.82A.63.63,0,0,1,151.76,316.66Zm-60.38-5.37a.63.63,0,0,1-.37-.12.61.61,0,0,1-.12-.85,36.54,36.54,0,0,1,6.32-6.53.61.61,0,1,1,.77.95,35.17,35.17,0,0,0-6.12,6.31A.6.6,0,0,1,91.38,311.29Zm12.49-10.45a.61.61,0,0,1-.28-1.15,36.42,36.42,0,0,1,10.72-3.43,37.27,37.27,0,0,1,7.67-.38.61.61,0,0,1,.57.64.59.59,0,0,1-.64.58,35.38,35.38,0,0,0-17.77,3.68A.66.66,0,0,1,103.87,300.84Zm29-1.37a.6.6,0,0,1-.22,0,34.8,34.8,0,0,0-8.52-2.14.61.61,0,0,1,.15-1.21,36,36,0,0,1,8.82,2.22.61.61,0,0,1,.34.79A.6.6,0,0,1,132.84,299.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.71,201.9c-3,.48-9.67,22.42-12.36,25.29-1.42,1.5-16.84-2.87-16.84-2.87L260.69,230s16.87,7,21.46,5.27c7.7-2.84,11.5-18.67,11.5-18.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,216.59a52,52,0,0,1-2.29,6.93c-1.35,3.33-3.32,7.12-5.89,9.58a9.79,9.79,0,0,1-3.32,2.16C277.57,237,260.69,230,260.69,230l1.82-5.67s15.42,4.37,16.84,2.87c2.69-2.87,9.39-24.81,12.35-25.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.87,224.41,256,219.14l-3,7s6.28,4.07,7.92,2.39Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.02 219.93 248.2 225.31 253.04 226.1 256.02 219.14 249.02 219.93",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.52 224.35 262.33 231.31 259.52 230.07 261.51 223.53 264.52 224.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.52 224.35 262.33 231.31 259.52 230.07 261.51 223.53 264.52 224.35",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.36,223.52c-1.35,3.33-3.32,7.12-5.89,9.58-.63-9.26,5.18-16.61,5.18-16.61A23,23,0,0,1,291.36,223.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.64,181.33a31.3,31.3,0,0,1,0,8.49s17.11,2.38,21.27-.79,6-22-3.27-23.78S295.47,169.77,297.64,181.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.14,416.8h-1.43l-.4-1.77-4.74,2.14h-12s-1.91-1.92,3.81-3.45a4.31,4.31,0,0,0,.81-.31c3.05-1.43,7.39-6.26,7.39-6.26h6.59a8.37,8.37,0,0,1,.54,1C285.42,409.55,286.66,412.6,284.14,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.7,408.1v0c-.87-1-4.83,3.29-7.73,4.74-2.59,1.29-5.5,1.86-6.79.55,3.05-1.43,7.85-7.67,7.85-7.67h5.3S284.39,407.48,284.7,408.1Z",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "277.57 407.15 280.59 381.3 290.07 384.1 283.48 407.37",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,248.8l-25.9-1.21s-6.92,44.58-7.55,73.06c-2,19.12-4.43,51.76-6.75,71.74a13.16,13.16,0,0,0,4.92,1.84,13.94,13.94,0,0,0,4.36.21c6-17.15,13-45.59,12.55-73.08C318.52,276.93,318.61,248.8,318.61,248.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,248.8s0,15.79-7.75,42.38c-2,7-4.6,14.75-7.82,23.16-.89,2.29-1.81,4.63-2.8,7,.49,27.49-6.57,55.93-12.56,73.08a13.82,13.82,0,0,1-4.34-.21,13.27,13.27,0,0,1-4.94-1.84c2.34-20,4.73-52.62,6.75-71.74.65-28.48,7.57-73.06,7.57-73.06Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.86,291.18c-2,7-4.6,14.75-7.82,23.16-2.21-22.71,3-35.54,3-35.54C308.42,281.71,309.94,286.13,310.86,291.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.16,416.8h-1.43l-.4-1.77-4.74,2.14h-12s-1.91-1.92,3.81-3.45a4.31,4.31,0,0,0,.81-.31c3.05-1.43,7.39-6.26,7.39-6.26h6.59a8.37,8.37,0,0,1,.54,1C322.44,409.55,323.69,412.6,321.16,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72,408.1v0c-.87-1-4.83,3.29-7.73,4.74-2.59,1.29-5.5,1.86-6.79.55,3.05-1.43,7.85-7.67,7.85-7.67h5.3S321.41,407.48,321.72,408.1Z",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.59 407.15 314.46 379.48 324.58 379.93 320.19 407.17 314.59 407.15",
    style: {
      fill: "#ffc2bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.55,394.87a27.24,27.24,0,0,0,4.87,1.14,10.89,10.89,0,0,0,4.08-.16c4.62-19.48,9.34-50.86,4-69.75,10.1-61.07-3.29-77.39-3.29-77.39l-22.73-2.47s7.32,51.67,9.8,76.93C312.44,344.87,314.33,370.19,313.55,394.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.55,394.87a27.24,27.24,0,0,0,4.87,1.14,10.89,10.89,0,0,0,4.08-.16c4.62-19.48,9.34-50.86,4-69.75,10.1-61.07-3.29-77.39-3.29-77.39l-22.73-2.47s7.32,51.67,9.8,76.93C312.44,344.87,314.33,370.19,313.55,394.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,199.3s-17.68,8.76-16.17.75c0,0-6.52-.06-10.81,2.56,0,0-2.54,10.65,0,39.28L290,255.74l10.46,3.16,3.45-10,4.18,10.57,18.18-5.68-3.67-10.67s1.85-24.53,7.39-35.74C330,207.34,329.14,199.18,318.82,199.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,199.3s-17.68,8.76-16.17.75c0,0-6.52-.06-10.81,2.56,0,0-2.32,11.5,0,39.28L290,255.74l10.46,3.16,3.45-10,4.18,10.57,18.18-5.68-3.67-10.67s1.85-24.53,7.39-35.74C330,207.34,329.14,199.18,318.82,199.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,184.07c-1.22,4.51-2.72,12.79.21,15.8,0,0,4,3.21-7.91,2.85-1,2.48-5,7.79-5,7.79s-1.82-5-1-6.84c-7.67-.66-.18-3.8-.18-3.8,5.13-1.2,5.28-4.94,4.66-8.45Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,187.07l-5.42,4.35a13.21,13.21,0,0,1,.24,2.49c1.95-.28,4.75-2.39,5.1-4.4A6.66,6.66,0,0,0,314,187.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.57,175c-1.37,7.29-1.79,10.4-5.95,13.9-6.26,5.26-14.86,2.48-15.68-5-.74-6.69,1.62-17.49,9.14-19.9A9.5,9.5,0,0,1,321.57,175Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.3,169.73c4,5.2-4.24,11.17,4,10.82s4.91-12,0-14.67S315.3,169.73,315.3,169.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,176.22c-.09.61-.48,1.09-.87,1.06s-.65-.55-.56-1.17.48-1.09.88-1.06S310.11,175.6,310,176.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,175.78c-.08.61-.48,1.09-.87,1.06s-.65-.55-.56-1.17.48-1.09.88-1.06S302.66,175.16,302.57,175.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.19,174.65l-1.39-.53S301.38,175.33,302.19,174.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,176.94a18.46,18.46,0,0,1-2.72,3.78,2.48,2.48,0,0,0,2.1.57Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,183.83a5.87,5.87,0,0,1-1,0,.15.15,0,0,1-.15-.19.19.19,0,0,1,.2-.17,5.18,5.18,0,0,0,4.18-1.62.18.18,0,0,1,.25,0,.19.19,0,0,1,0,.26A5.48,5.48,0,0,1,307,183.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,172.9a.32.32,0,0,1-.25-.11,2.62,2.62,0,0,0-2.36-.9.33.33,0,0,1-.4-.29.39.39,0,0,1,.31-.43,3.36,3.36,0,0,1,3,1.11.38.38,0,0,1,0,.52A.39.39,0,0,1,312.1,172.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,172.23a.33.33,0,0,1-.25-.08.36.36,0,0,1,0-.51,3.8,3.8,0,0,1,3.08-1.37.33.33,0,0,1,.29.4.39.39,0,0,1-.42.32,3,3,0,0,0-2.43,1.11A.36.36,0,0,1,300.9,172.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.64,175.09l-1.39-.53S308.83,175.77,309.64,175.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,165.69s1.43,8.6,7.14,10,1.08-8.83,1.08-8.83-1.2-4.66-8.91-4.66-16.62,7.83-14.15,19.1a12.44,12.44,0,0,1,1.29-6.72C300.64,171.64,302.4,174.2,312.48,165.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.67,163.52c8.16,3.26,11.13,8.6,10.43,14.53s-8,12.22-9.19,12.44l-3.67.52s5.64-7.84,4.55-10.5-2.17-2.92-2.17-2.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28,182a5.07,5.07,0,0,1-3.1,2.72c-1.69.45-2.43-1.5-1.87-3.44.51-1.75,2-4.09,3.67-3.67S323.14,180.32,322.28,182Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,199.63c-5.52,5.13-8.49,32.17-7.7,40.9s7.7,32.1,7.7,32.1l10.89-.89s-2.63-16.21-9.36-29.14c0,0,4.29-32.13,8.24-40.12,0,0-3.75-1.49-4.91-1.83S321.76,199.63,321.76,199.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,271.74l-10.89.89s-2.32-7.81-4.4-16.09c-.88-3.45-1.71-7-2.33-10.05a55.24,55.24,0,0,1-1-6c-.09-1-.14-2.23-.14-3.64.05-11,2.93-32.71,7.83-37.26l1.87.35c1.07.22,2.34.48,3,.67,1.16.34,4.91,1.83,4.91,1.83a31.05,31.05,0,0,0-1.62,4.4c-.14.53-.31,1.09-.45,1.67-1.74,6.49-3.38,15.79-4.55,23-1,6.29-1.62,11-1.62,11q1.06,2.06,2,4.19A117.75,117.75,0,0,1,332.65,271.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,199.63s4.27,8.79,3.28,17.79l-6.43-5,3.66,4.75-8.21,15S314.72,205.28,321.76,199.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54,200.09s-6.66,11.39-5.47,40.67l-4,29.67h-4.35l4.84-29.67s-5.17-22.42.11-38.86A25.79,25.79,0,0,1,300.54,200.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54,200.09s-6.66,11.39-5.47,40.67l-4,29.67h-4.35l4.84-29.67s-5.17-22.42.11-38.86A25.79,25.79,0,0,1,300.54,200.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.49,200.09s-1-.56-3.32.37-7.85,13.13-7.85,13.13l4.22-2.44-2.37,2.44L295,228.22S298.22,201.88,301.49,200.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,198.05s-3.93,2.74-3.46,5.62l-6.71,1.65S301.33,198.53,307.53,198.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,206.52l-9.4-3.05s5-4,6.52-6.18l3.11,2.33h0C319.82,199.8,320.74,202.08,319.51,206.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,198.05s-3.93,2.74-3.46,5.62l-6.71,1.65S301.33,198.53,307.53,198.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,206.52l-9.4-3.05s5-4,6.52-6.18l3.11,2.33h0C319.82,199.8,320.74,202.08,319.51,206.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.29,246.79h-1.37c-2.7,0-5.88-.14-8.89-.31-5.81-.33-11-.79-11-.79l.42-7.25,5.83.08.29-.54a24.22,24.22,0,0,0,3.38-1.1,102.45,102.45,0,0,0,9.92-4.72l1.07-.59c-1,6.29-1.62,11-1.62,11Q324.37,244.66,325.29,246.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.53,202.48c3.5,3.08,9.72,30.93,7.7,34.47s-25.65,7.56-25.65,7.56l-2.27-6s18.71-5.16,18.71-7.2S326.75,221,326.75,221s-.76-9.51,1.88-14.17A25.6,25.6,0,0,1,331.53,202.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.53,202.48c3.5,3.08,9.72,30.93,7.7,34.47s-25.65,7.56-25.65,7.56l-2.27-6s18.71-5.16,18.71-7.2S326.75,221,326.75,221s-.76-9.51,1.88-14.17A25.6,25.6,0,0,1,331.53,202.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,239.05l-7.81-1,1.53,7.41s7.48-.24,7.86-2.55Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.71 242.71 301.11 247.59 305.54 245.47 304.01 238.06 298.71 242.71",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.97 237.48 316.14 244.46 313.12 245.04 311.03 238.53 313.97 237.48",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.97 237.48 316.14 244.46 313.12 245.04 311.03 238.53 313.97 237.48",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.52,252.86l4.72,9-9.69,1.48s-3.07-9.19-.44-10.7Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.97 270.43 227.97 269.7 228.55 263.38 238.24 261.9 234.97 270.43",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 248.38 234.46 253.94 226.64 255.88 224.4 250.36 232.31 248.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 248.38 234.46 253.94 226.64 255.88 224.4 250.36 232.31 248.38",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,181.51c-2.65,2.62-.15,34.91-.07,38.76s11.38,32.41,11.38,32.41l9.13-2.8-9.33-29.78c-1.37-4.34-1.1-15.46-1.2-20.18-.08-3.67-.28-9.43-2.87-12.81A23.57,23.57,0,0,0,213,181.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,181.51c-2.65,2.62-.15,34.91-.07,38.76s11.38,32.41,11.38,32.41l9.13-2.8-9.33-29.78c-1.37-4.34-1.1-15.46-1.2-20.18-.08-3.67-.28-9.43-2.87-12.81A23.57,23.57,0,0,0,213,181.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.75,219.1l9.86-2.61-.69,9.78s-9.64,1-10.54-1.93Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.2 221.55 251.96 228.22 245.92 226.27 246.61 216.49 254.2 221.55",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,192.83l-.92-9.63c-1.6-.27-2.44-3.21-4.24-3.38a153.38,153.38,0,0,0-17.16,0c-1.71.09-3.43.24-5,.42l-5.11,20.5c.66,5.63,1,11.09,1.25,16.18.62,14.94-.21,17.67.07,21.28h40.4c-1.32-23.72-2.55-37.71-3.36-45.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,192.83l-.92-9.63c-1.6-.27-2.44-3.21-4.24-3.38a153.38,153.38,0,0,0-17.16,0c-1.07.06-2.14.14-3.2.23l-6.69,23.06c.49,4.79.81,9.44,1,13.81.62,14.94-.21,17.67.07,21.28h40.4c-1.13-23.55-2.4-37.63-3.28-45.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.81,182.35a30.15,30.15,0,0,0-2.5,3l-.5,4.65s7,20.91,7.59,30.63l-2.58,2.47-4.51-3.93a262.55,262.55,0,0,0-2-29.12l-1.7-4.13s-4.39-1.9-6.23-4S205.81,182.35,205.81,182.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,162.49l4.6,3.81,6.25,5.19a20.69,20.69,0,0,0-.39,2.53c-.34,3.39.79,4.37,4.27,5.67a6.64,6.64,0,0,1-2.1,4.56c0,.55-1.5,1.44-1.5,1.44a10.2,10.2,0,0,0-1.28-1.2c-9.61-.17-10.88-4.62-10.88-4.62C193.14,176.18,191.71,168,190.43,162.49Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.28,171.49a20.69,20.69,0,0,0-.39,2.53c-2.34-.47-5.45-3-5.78-5.34a11,11,0,0,1-.08-2.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.15,142.33s4.1,9.75-.3,15-9.16-13.62-9.16-13.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,169.35a9.49,9.49,0,0,0,11.47.9,10.58,10.58,0,0,0,4.65-6.24,10.26,10.26,0,0,0,.24-1.1c1.08-6.87-.81-17.92-8.39-20.33A10.3,10.3,0,0,0,189.88,154C190.91,161.4,191.16,165.82,195.26,169.35Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.43,155.15c0,.61.4,1.08.81,1s.68-.56.63-1.17-.41-1.08-.81-1.05S201.38,154.53,201.43,155.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,154.61c0,.61.41,1.08.81,1s.68-.55.63-1.16-.41-1.08-.81-1.05S208.28,154,208.33,154.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.16,155.08a21.69,21.69,0,0,0,3.32,5,3.52,3.52,0,0,1-2.89.78Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,151.58a.39.39,0,0,1-.38,0,2.91,2.91,0,0,0-2.58-.28.36.36,0,0,1-.48-.17.35.35,0,0,1,.17-.47h0a3.52,3.52,0,0,1,3.26.31.36.36,0,0,1,.13.49h0A.74.74,0,0,1,210.63,151.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,152.51a.29.29,0,0,1-.2,0,.36.36,0,0,1,0-.51h0a3.53,3.53,0,0,1,3.1-1.09.35.35,0,0,1,.28.42h0a.38.38,0,0,1-.43.28h0a2.87,2.87,0,0,0-2.43.9A.37.37,0,0,1,199.85,152.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,144.16l.83,1.33c-2.36,1.12-1.51,3.92-.85,5.15,1.41,2.63.38,7.12-1.52,9.1,0,0-.22-1.19-1.2-.78s0,5.57,0,5.57-.86,1.46-3.37-4.87c-2.32-5.87-3.16-10.89-2.21-13.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,160.35a7.21,7.21,0,0,0,4.37,3.29c2.44.61,3.58-1.59,2.86-3.86-.67-2-2.73-4.81-5.15-4.39S185.93,158.33,187.09,160.35Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,162.35a23.35,23.35,0,0,0-1.53,2.88l-.56-.15c-2.51-.68-3.44-1.83-3.72-2.9a3.53,3.53,0,0,1,.32-2.44,12.27,12.27,0,0,0,4.64,2.37C205.93,162.27,206.26,162.35,206.26,162.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,162.11l-.47.83c-2.37-.65-3.94-1.43-4.49-2.34a3.33,3.33,0,0,1,.32-.86A12.27,12.27,0,0,0,205.41,162.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,165.08c-2.51-.68-3.44-1.83-3.72-2.9a8.55,8.55,0,0,1,2.63,1.32A3.07,3.07,0,0,1,204.17,165.08Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82,145.72a8.59,8.59,0,0,0,2-6.34s-14.39-2.48-20.95,0-2.49,13.14-2.49,13.14,6.75-5.57,9.14-7,9.81,1.17,9.81,1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,175.74s1.83,4.85,8.88,8.28l1.9,1.74-3.16-.8-3.2,4-8.91-8.92S189.5,175.8,191.06,175.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.84,185.76l.51-2.78a10.5,10.5,0,0,0-.7-5.26s-.44-.1-.69-1.29l1.19.3s6.3,2.48,7.21,10.65l-5-3.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.84,185.76l.51-2.78a10.5,10.5,0,0,0-.7-5.26s-.44-.1-.69-1.29l1.19.3s6.3,2.48,7.21,10.65l-5-3.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,175.74s1.83,4.85,8.88,8.28l1.9,1.74-3.16-.8-3.2,4-8.91-8.92S189.5,175.8,191.06,175.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.05 409.37 226.54 410.26 226.97 405.34 228.14 391.94 219.64 391.04 218.35 405.84 218.05 409.37",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.64 408.29 183.87 408.29 183.94 406.43 183.96 406.2 184.37 394.25 184.38 394.01 184.55 389.44 176.31 389.44 175.64 408.29",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.64 391.04 218.35 405.84 226.97 405.34 228.14 391.94 219.64 391.04",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.69 407.25 175.7 407.25 183.94 406.2 183.96 406.2 184.38 394.67 184.37 394.67 176.12 395.33 175.7 406.88 175.69 407.25",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,407.8H175a.71.71,0,0,0-.7.56l-1.63,7.34a1.22,1.22,0,0,0,.94,1.44.82.82,0,0,0,.27,0c3.23-.05,5.59-.25,9.66-.25,2.5,0,10,.26,13.51.26s3.91-3.41,2.5-3.73c-6.35-1.38-11.13-3.3-13.16-5.12A2,2,0,0,0,185,407.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,407.54h-10a.71.71,0,0,0-.7.56l-1.63,7.34a1.19,1.19,0,0,0,1.21,1.46c3.24,0,5.59-.25,9.66-.25,2.5,0,10.06.26,13.51.26s3.91-3.41,2.5-3.73c-6.35-1.38-11.13-3.3-13.16-5.12A2,2,0,0,0,227.45,407.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,405.15h11.93s9.6-36.39,13.4-62.58c.6-4.07,1.23-9.4,1.87-15.62,1-10,2.05-22.08,3-33.68,2.85,7.66,5,18.62,6.7,31a592.33,592.33,0,0,1,5.37,79.79h12.08c7.76-59.24.46-119.45-4.6-150.71-1-6.34-2-11.48-2.67-15.19H181.25c0,.84.27,7,.63,15.93.81,20.4,2,55.47.75,75.91C181.58,347.8,174.58,405.15,174.58,405.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.62,409a9.49,9.49,0,0,1-2,.37.18.18,0,0,1-.16-.28c.18-.24,1.76-2.29,2.75-2.23a.66.66,0,0,1,.55.35,1,1,0,0,1,.08,1A2,2,0,0,1,231.62,409ZM230,409c1.37-.16,2.3-.5,2.53-.95a.62.62,0,0,0-.08-.63.3.3,0,0,0-.26-.18C231.66,407.16,230.66,408.15,230,409Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,409.34h-.09a.16.16,0,0,1-.13-.11c0-.09-.87-2.1-.37-3a.91.91,0,0,1,.64-.47.7.7,0,0,1,.77.31c.42.73-.17,2.58-.74,3.24Zm0-3.23a.5.5,0,0,0-.31.26,3.92,3.92,0,0,0,.27,2.44,3.55,3.55,0,0,0,.52-2.58c0-.09-.14-.19-.4-.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,409a9.29,9.29,0,0,1-2,.37.19.19,0,0,1-.17-.09.17.17,0,0,1,0-.19c.18-.24,1.76-2.29,2.75-2.23a.63.63,0,0,1,.54.35,1,1,0,0,1,.09,1A2.07,2.07,0,0,1,189.18,409Zm-1.61,0c1.36-.16,2.3-.5,2.53-.95a.62.62,0,0,0-.08-.63.31.31,0,0,0-.26-.18C189.23,407.16,188.23,408.15,187.57,409Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,409.34h-.08a.16.16,0,0,1-.13-.11c0-.09-.87-2.1-.37-3a.9.9,0,0,1,.63-.47.69.69,0,0,1,.77.31c.42.73-.16,2.58-.74,3.24Zm0-3.23a.5.5,0,0,0-.31.26,3.92,3.92,0,0,0,.27,2.44,3.6,3.6,0,0,0,.52-2.58c-.05-.09-.15-.19-.4-.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.76,293.26c2.85,7.67,5,18.62,6.7,31.05,4.06-16.62-5.65-47.36-5.65-47.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,245.39l-.64-10.18h-39.9s-1.25,2.39-1.12,9.27Z",
    style: {
      fill: "#263238"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 218.48,
    y: 236.49,
    width: 4.27,
    height: 2.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.25,
    y: 236.49,
    width: 18.03,
    height: 2.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182.42,
    y: 236.49,
    width: 15.62,
    height: 2.95
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,238.2c0,.84.27,7,.63,15.93,7.71,2,24.8,1.33,24.8,1.33l1.58-1.21.59,1.21,15.46-2.07c-1-6.34-2-11.48-2.67-15.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.68,
    y: 236.29,
    width: 4.88,
    height: 3.35,
    rx: 0.55,
    transform: "translate(418.24 475.94) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,244.31a47.28,47.28,0,0,1-1.69,8.72l-27.29-.8s.54-21.49.77-30.23a157.55,157.55,0,0,0-1.27-16.82c-.48-4.36-1-8.84-1.54-12.71a6.25,6.25,0,0,1-.08-.86,12,12,0,0,1,9.32-12.38l20,31,0,.08s.15.74.34,2.05c.42,2.68,1.12,7.73,1.53,13.7A105.52,105.52,0,0,1,208.36,244.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,178.25l-2.51,1.05,1.12,7.2,4.65,4-1.46,5.1,16.92,14.7S193.25,189.81,188,178.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,178.25l-2.51,1.05,1.12,7.2,4.65,4-1.46,5.1,16.92,14.7S193.25,189.81,188,178.25Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.13,251.05l-16,1.09-.75-7.83h0l-1.78-18.76-1.16-12.15c.18-.45.36-.89.51-1.33.25-.63.49-1.24.7-1.85,7.88-22-.64-30.63-.64-30.63a17,17,0,0,1,11.29,5.24c2.94,6.49,5.31,17.49,5.56,28.94.14,6.34.06,11.92,0,15.06,0,1.71-.07,2.7-.07,2.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,179.58s6.34,3.11,8.83,8.76l-1.43,1.88,3.1,5.24-11.08,17.93S210.18,186.19,206,179.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,179.58s6.34,3.11,8.83,8.76l-1.43,1.88,3.1,5.24-11.08,17.93S210.18,186.19,206,179.58Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83,228.82c-3.57-.54-9-1.46-14.29-2.78-.66-.15-1.31-.32-2-.5a52.92,52.92,0,0,1-8.45-2.92c-6.77-3.19-15-12.35-19.25-17.44-.48-4.36-1-8.84-1.54-12.71a6.25,6.25,0,0,1-.08-.86h10.46s15.41,18.71,18.21,20.45l.24.11a7.44,7.44,0,0,0,.84.17c2.82.44,10.78,1.06,15.83,1.42C223,220.1,222.9,225.68,222.83,228.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.3 218.14 238.24 218.71 236.46 226.57 230.52 226.1 232.3 218.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.3 218.14 238.24 218.71 236.46 226.57 230.52 226.1 232.3 218.14",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,187.38c-4.75,14.3,15.33,29.86,20.36,34S233,227.2,233,227.2l1.57-9.4s-27.19-3.1-29.19-4.41-15-17.59-18.35-22.74S177.78,187.38,177.78,187.38Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesI);
export default __webpack_public_path__ + "static/media/servicesI.a938a321a4fa0a34269856107ba5b7f6.svg";
export { ForwardRef as ReactComponent };